.statList {
  display: flex;
  flex-direction: column;

  .statRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--vc-border);
    font-size: var(--vc-text-sm);

    &:last-child {
      border-bottom: 0;
    }
  }

  .statKey {
    color: var(--vc-text-muted);
  }

  .statValue {
    font-weight: var(--vc-weight-semibold);
    text-align: right;
  }
}
